import { atom, useAtom } from 'jotai';

export const formButtonEnabledAtom = atom(true);

export function useFormButtonEnabledAtom() {
  return useAtom(formButtonEnabledAtom);
}